import { BaseDTO } from "../../../../core/dto/BaseDTO";

export class ChatMessageDTO extends BaseDTO {
  id: string;
  sessionId: string;
  role: string;
  content: string;
  metadata: any;
  createdAt: Date;
  searchResults?: any[];
  finalContentDocument?: any[];

  constructor() {
    super();
  }

  override bindData(obj: any): void {
    if (obj == null) {
      return;
    }
    super.bindData(obj);
    this.id = obj.id;
    this.sessionId = obj.session_id;
    this.role = obj.role;
    this.content = obj.content;
    this.metadata = obj.metadata;
    this.createdAt = obj.created_at ? new Date(obj.created_at) : new Date();
  }
}

export class ChatSessionDTO extends BaseDTO {
  id: string;
  userId: string;
  session_title: string;
  settings: any;
  createdAt: Date;
  updatedAt: Date;
  messages: ChatMessageDTO[] = [];

  constructor() {
    super();
  }

  override bindData(obj: any): void {
    if (obj == null) {
      return;
    }
    super.bindData(obj);
    this.id = obj.id;
    this.userId = obj.user_id;
    this.session_title = obj.session_title;
    this.settings = obj.settings || {};
    this.createdAt = obj.created_at ? new Date(obj.created_at) : new Date();
    this.updatedAt = obj.updated_at ? new Date(obj.updated_at) : new Date();
    // Messages are loaded separately, not included in the session list endpoint
  }
}

export interface ChatSessionListResponse {
  sessions: ChatSessionDTO[];
  total: number;
  limit: number;
  offset: number;
}
